// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "../channels"

ActiveStorage.start()

import "../controllers"
import '../css/application.scss'
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap
import '@popperjs/core'

require.context('../images', true)

require("../src/noticeContainer")

// Limpiar Bootstrap modal artifacts antes de que Turbo reemplace el body
// (necesario cuando un form dentro de un modal se envía via Turbo)
document.addEventListener('turbo:before-render', () => {
  document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove())
  document.body.classList.remove('modal-open')
  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('padding-right')
})

document.addEventListener('turbo:before-cache', () => {
  // Limpiar elementos marcados
  document.querySelectorAll('.clear-before-cache').forEach((el) => el.innerHTML = '')

  // Cerrar modals Bootstrap abiertos y limpiar artifacts
  document.querySelectorAll('.modal.show').forEach((modal) => {
    const instance = bootstrap.Modal.getInstance(modal)
    if (instance) instance.hide()
    modal.classList.remove('show')
    modal.style.display = ''
    modal.removeAttribute('aria-modal')
    modal.removeAttribute('role')
    modal.setAttribute('aria-hidden', 'true')
  })

  // Eliminar backdrops huérfanos
  document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove())

  // Limpiar estado del body
  document.body.classList.remove('modal-open')
  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('padding-right')

  // Destruir popovers para evitar elementos DOM huérfanos
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
    const instance = bootstrap.Popover.getInstance(el)
    if (instance) instance.dispose()
  })
})
